import axios from "axios";
import { apiConstants } from "./components/Constant/constants";
import { logout } from "./helpers/authentication/authentication";
import { appConfig } from "./config";

const apiUrl = appConfig.apiHost || "https://admin.stripperfans.com/api/user/";

// Response Interceptors
axios.interceptors.response.use(
  (response) => response,
  function (error) {
    if (error?.response?.status === 401) {
      logout()
    }
    return Promise.reject(error);
  }
);

const isInvalidToken = (data) => {
  const { success, error_code } = data
  return !success && (error_code === 1002 || error_code === 1003)
}

const Environment = {
  postAuthMethod: async (action, object, configs = {}) => {
    return Environment.postMethod(action, object, configs, false)
  },

  postMethod: async (action, object, configs = {}, showToken = true) => {
    const jwtToken = localStorage.getItem('jwtToken') || ''

    const url = apiUrl + action;
    let formData = new FormData();

    if (showToken) {
      // device type and login type
      formData.append("device_type", apiConstants.DEVICE_TYPE);
      formData.append("device_token", apiConstants.DEVICE_TOKEN);
    }

    // Append Data
    let socialLoginUser = 0;
    for (var key in object) {
      if (key === 'post_files') {
        for (let i = 0; i < object[key].length; i++) {
          formData.append('post_files[]', object[key][i])
        }
      } else {
        formData.append(key, object[key]);
        if (key === "social_unique_id" || key === "id_token") {
          socialLoginUser = 1;
        }
      }
    }
    if (!socialLoginUser) {
      formData.append("login_by", apiConstants.LOGIN_BY);
    }

    if (!configs.headers)
      configs = { ...configs, headers: { Authorization: `Bearer ${jwtToken}` } }

    const result = await axios.post(url, formData, configs);
    if (isInvalidToken(result.data) && action !== "public_profile" && action !== "other_profile") {
      logout()
    }
    return result
  },

  getMethod: async (action, object) => {
    const url = apiUrl + action;
    let formData = new FormData();

    // device type and login type
    formData.append("login_by", apiConstants.LOGIN_BY);
    formData.append("device_type", apiConstants.DEVICE_TYPE);
    formData.append("device_token", apiConstants.DEVICE_TOKEN);

    // Append data
    for (var key in object) {
      formData.append(key, object[key]);
    }

    const result = await axios.get(url, formData);
    if (isInvalidToken(result.data)) {
      logout()
    }
    return result
  }
};

export default Environment;
